if (typeof document !== 'undefined') {
  const elements = document.querySelectorAll(`.ofg-factblock`);

  elements.forEach(element => {
    const button = element.querySelector('button');

    if (button) {
      button.addEventListener('click', () => {
        element.classList.toggle('ofg-factblock-expanded');
      });
    }
  });
}